<script lang="ts">

    let output : string = "";
    let input : string = "";

    function HexToByte(hex : string) : number
    {
        return parseInt(hex,16);
    }

    function replaceAll(str : string, find : string, replace : string) : string {
        var escapedFind=find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return str.replace(new RegExp(escapedFind, 'g'), replace);
    }

    function HexBufToString(hexbuf : string) : string
    {
        let result : string = "";
        let temp : string = replaceAll(hexbuf," ","");

        for(let i : number=0; i<temp.length/2; i++)
        {
            let val : number = HexToByte(temp.substring(i*2,i*2+2));
            result = result.concat(String.fromCharCode(val));
        }

        return result;
    }

    function OnInputChange()
    {
        output = HexBufToString(input);
    }
    
</script>

<div class="columns">
    <div class="column">

        <h1 class="title" style="color:red;">Hex to ASCII text Buffer </h1>

        <hr/>
        <p>Use this utility to convert HEX buffers to its text representation. The conversion is done on the fly, 
            so copy and paste the buffer into the textbox to see immediate results.</p>
        <p>eg: 48 65 6c 6c 6f becomes "Hello"</p>
        <hr/>
        <div class="field">
            <label class="label">Input HEX Buffer:</label>
            <div class="control">
                <textarea class="textarea" placeholder="Enter a HEX buffer" rows="5" 
                    bind:value={input}
                    on:input={OnInputChange}
                    ></textarea>
            </div>
        </div>

        <div class="field">
            <label class="label">Output Ascii String:</label>
            <div class="control">
                <textarea readonly class="textarea" placeholder="String output will appear here" rows="5">{output}</textarea>
            </div>
        </div>

    </div>
</div>

